import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useWallet } from "../wallet/context";
import { fetchCounts, type Counts } from "../site/counts";

/** Home: the one line, the three steps, and counts read from the public API. */
export function HomePage() {
  const { identity } = useWallet();
  const [counts, setCounts] = useState<Counts | null>(null);
  const [countsErr, setCountsErr] = useState(false);
  useEffect(() => { fetchCounts().then(setCounts, () => setCountsErr(true)); }, []);
  return (
    <div>
      <h1 data-testid="tagline">A network that describes people without exposing them.</h1>
      <p className="lead">Say what you did. People who know vouch for it. Organisations confirm it. Anyone can check every signature.</p>
      <ol className="steps" data-testid="steps">
        <li><b>Claim</b><span>Describe something you did, in your own words, signed with a key that lives on your device.</span></li>
        <li><b>Vouch</b><span>Send a one-time link. Peers, organisations and issuers vouch with their own keys.</span></li>
        <li><b>Share</b><span>Share the claim's page. It shows who vouched and how, and every signature checks out in the reader's browser.</span></li>
      </ol>
      <div className="row" style={{ margin: "18px 0" }}>
        <Link className="btn primary" to={identity ? "/claim" : "/me?return=/claim"}>Claim something you did</Link>
        <Link className="btn" to="/how-it-works">How it works</Link>
      </div>
      <div className="counts" data-testid="counts" aria-live="polite">
        {counts ? (<>
          <div><b data-testid="count-claims">{counts.claims.toLocaleString()}</b><span>claims</span></div>
          <div><b data-testid="count-vouches">{counts.vouches.toLocaleString()}</b><span>vouches</span></div>
          <div><b data-testid="count-anchors">{counts.anchors.toLocaleString()}</b><span>anchors</span></div>
          <div><b data-testid="count-issuers">{counts.issuers.toLocaleString()}</b><span>organisations</span></div>
        </>) : <p className="hint">{countsErr ? "Counts are unavailable right now." : "Counting from the public log…"}</p>}
      </div>
      <p className="hint">From the rail's public counts. <Link to="/orgs">The organisations</Link> · <Link to="/live">Watch it live</Link></p>
    </div>
  );
}
